import axios from "axios"
import {
  Building,
  Building2Icon,
  DollarSign,
  User,
  Users2
} from "lucide-react"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { CollectionQuery } from "../../../models/collection.model"
import { useCurrentUser } from "../../../shared/hooks/current-user.hook"
import {
  useLazyCountDashboardLeasesQuery,
  useLazyCountDashboardOwnersQuery,
  useLazyCountDashboardPropertiesQuery,
  useLazyCountDashboardRequestsQuery,
  useLazyCountDashboardTenantsQuery,
  useLazyCountDashboardUnitsQuery,
  useLazyGetTotalLeasePaymentsForPeriodQuery,
} from "../store/dashboard.query"
import StatCard from "./stat-cart"
import { notification } from "../../../shared/component/notification/utility/notification"

export function Summary() {
  const [countOwners, owners] = useLazyCountDashboardOwnersQuery()
  const [countProperties, properties] = useLazyCountDashboardPropertiesQuery()
  const [countTenants, tenants] = useLazyCountDashboardTenantsQuery()
  const [countUnits, units] = useLazyCountDashboardUnitsQuery()
  const [countLeases, leases] = useLazyCountDashboardLeasesQuery()
  const [countRequests, requests] = useLazyCountDashboardRequestsQuery()
  const [getTotalLeasePaymentsForPeriod, totalLeasePayments] =
    useLazyGetTotalLeasePaymentsForPeriodQuery()
  const [userInfo, userId, ownerInfo] = useCurrentUser()
  const { t } = useTranslation()

  useEffect(() => {
    async function fetchOwnerInfo() {
      axios
        .get(
          `${import.meta.env.VITE_APP_API}/owners/get-owner/${
            userInfo?.id as string
          }?includes[0]=parentOwner`,
          {
            headers: {
              Authorization: `Bearer ${
                localStorage.accessToken ? await localStorage.accessToken : ""
              }`,
            },
          },
        )
        .then((response) => {
          localStorage.setItem("ownerInfo", JSON.stringify(response.data))
          return response.data
        })
        .catch(function (error) {
          if (error.response) {
            return
          } else if (error.request) {
            notification("error", "Check your internet connection")
          } else {
            console.log("Error", error.message)
          }
        })
    }

    fetchOwnerInfo();
  }, [])
  const generateCollection = (): CollectionQuery => {
    if (userInfo?.role?.key == "super_admin") {
      return { count: true }
    }

    return {
      count: true,
      filter: [
        [
          {
            field: "ownerId",
            value: ownerInfo?.parentOwnerId as string,
            operator: "=",
          },
        ],
      ],
    }
  }

  function fetch() {
    if (
      userInfo?.role?.key == "super_admin" ||
      userInfo?.role?.key == "admin" ||
      userInfo?.role?.key == "owner"
    ) {
      countOwners({ count: true })
      countProperties(generateCollection())
      countTenants(generateCollection())
    }

    if (userInfo?.role?.key == "super_admin") {
      countUnits({ count: true })
    } else if (userInfo?.role?.key == "owner") {
      countUnits({
        count: true,
        includes: ["property"],
        filter: [
          [
            {
              value: userInfo?.id as string,
              operator: "=",
              field: "property.ownerId",
            },
          ],
        ],
      })
    }

    if (userInfo?.role?.key == "tenant") {
      countLeases({
        count: true,
        filter: [[{ value: userId, operator: "=", field: "tenantId" }]],
      })

      countRequests({
        count: true,
        filter: [[{ value: userId, operator: "=", field: "tenantId" }]],
      })
    }

    getTotalLeasePaymentsForPeriod({})
  }

  useEffect(() => {
    fetch()
  }, [])

  return (
    <>
      {userInfo?.role?.key == "super_admin" && (
        <StatCard
          name={t("owner", { count: 2 })}
          icon={User}
          value={owners?.data?.count}
          color="#6366F1"
          loading={owners?.isFetching}
        />
      )}
      {userInfo?.role?.key == "owner" &&
        ownerInfo?.id === ownerInfo?.parentOwnerId && (
          <>
            <StatCard
              name={t("pricePerMonth")}
              icon={DollarSign}
              value={ownerInfo?.pricePerMonth?.toFixed(2)}
              color="#85BB65"
              loading={false}
            />
            {/* <StatCard
              name={"Total " + t("leasePayment", { count: 2 })}
              icon={DollarSign}
              value={totalLeasePayments?.data?.total?.toFixed(2)}
              color="#85BB65"
              loading={false}
            /> */}
          </>
        )}

      {userInfo?.role?.key == "tenant" && (
        <>
          <StatCard
            name={t("lease", { count: 2 })}
            icon={Building2Icon}
            value={leases?.data?.count}
            color="#8B5CF6"
            loading={leases?.isFetching}
          />
          <StatCard
            name={t("request", { count: 2 })}
            icon={Building2Icon}
            value={requests?.data?.count}
            color="#8B5CF6"
            loading={requests?.isFetching}
          />
        </>
      )}

      {userInfo?.role?.key != "tenant" && (
        <>
          <StatCard
            name={t("property", { count: 2 })}
            icon={Building2Icon}
            value={properties?.data?.count}
            color="#8B5CF6"
            loading={properties?.isFetching}
          />
          <StatCard
            name={t("unit", { count: 2 })}
            icon={Building}
            value={units?.data?.count}
            color="#EC4899"
            loading={units?.isFetching}
          />
          <StatCard
            name={t("tenant", { count: 2 })}
            icon={Users2}
            value={tenants?.data?.count}
            color="#10B981"
            loading={tenants?.isFetching}
          />
        </>
      )}
    </>
  )
}
